import {
  ActiveGroupClearedResponse,
  activeGroupClearedResponseSchema,
  Group,
  GroupContext,
  groupContextSchema,
  SetActiveGroupRequest,
  setActiveGroupRequestSchema,
} from "@/src/models/group";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function clearActiveGroup(): Promise<void> {
  const response = await fetchJSON<ActiveGroupClearedResponse>("/api/session/group", { method: "DELETE" });

  activeGroupClearedResponseSchema.parse(response);
}

export async function getGroupContext(): Promise<GroupContext> {
  const response = await fetchJSON<GroupContext>("/api/groups");

  return groupContextSchema.parse(response);
}

export async function setActiveGroup(request: SetActiveGroupRequest): Promise<GroupContext> {
  const body = setActiveGroupRequestSchema.parse(request);
  const response = await fetchJSON<GroupContext>("/api/session/group", {
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
    },
    method: "PUT",
  });

  return groupContextSchema.parse(response);
}

export async function getGroupForStytchOrgId(stytchOrgId: string): Promise<Group | null> {
  return fetchJSON<Group>(`/api/groups/${stytchOrgId}`);
}

export async function getGroupForSubdomain(subdomain: string): Promise<Group | null> {
  return await fetchJSON<Group | null>(`/api/groups/subdomain/${subdomain}`);
}
